import { InquiryDetail, InquiryStatusEnum } from '@crema/models/inquiry';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type InquiryDetailState = {
  info?: InquiryDetail;
};

const initialState: InquiryDetailState = {};

export const inquiryDetailSlice = createSlice({
  name: 'order_detail',
  initialState,
  reducers: {
    setInfo: (state, action: PayloadAction<InquiryDetail | undefined>) => {
      state.info = action.payload;
    },
    setStatusCode: (state, action: PayloadAction<InquiryStatusEnum>) => {
      if (state.info) state.info.inquiryStatusCode = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setInfo, setStatusCode } = inquiryDetailSlice.actions;

export default inquiryDetailSlice.reducer;
